import { createVanIconComponent } from "./van"

const GoldCoinOutlined = createVanIconComponent("gold-coin-o")
export default GoldCoinOutlined
